import type { ProductConfig } from "../type"
import FavIcon from "./assets/com-fav.png"
import Logo from "./assets/inmetro-black.png"
import Img1CD from "./itens-de-seguranca/conformidade-declarado/1.png"
import Img2CD from "./itens-de-seguranca/conformidade-declarado/2.png"
import Img3CD from "./itens-de-seguranca/conformidade-declarado/3.png"
import Img4CD from "./itens-de-seguranca/conformidade-declarado/4.png"
import Img5CD from "./itens-de-seguranca/conformidade-declarado/5.png"
import Img6CD from "./itens-de-seguranca/conformidade-declarado/6.png"
import Img1REP from "./itens-de-seguranca/reparado/1.png"
import Img2REP from "./itens-de-seguranca/reparado/2.png"
import Img3REP from "./itens-de-seguranca/reparado/3.png"
import Img4REP from "./itens-de-seguranca/reparado/4.png"
import Img5REP from "./itens-de-seguranca/reparado/5.png"
import Img6REP from "./itens-de-seguranca/reparado/6.png"
import Img7REP from "./itens-de-seguranca/reparado/7.png"
import LandingPage from "./LandingPage"
import { QrCodeQueryLoading } from "./qr-code-query-loading"
import { SealMask } from "./seal-mask"

export const validaInstrumentoConfig: ProductConfig = {
	product: {
		name: "Validador",
		domains: [
			"validainstrumento.primi.com.br",
			"www.validainstrumento.primi.com.br",
			"validainstrumento.homol.primi.com.br",
			"www.validainstrumento.homol.primi.com.br",
			"validainstrumento.com.br",
			"www.validainstrumento.com.br",
		],
		description:
			"Gerencie os selos de autenticidade do seu produto com numeração sequencial. Cada produto possui seu selo único com controle de lotes numerados.",
	},
	LandingPage,
	Logo,
	SealMask,
	QrCodeQueryLoading,
	FavIcon: FavIcon,
	theme: {
		colors: {
			cssVariables: {
				"--primary": "oklch(0.7232 0.134 222.68)",
			},
			fallback: {
				primary: "purple-900",
				secondary: "amber-300",
				accent: "orange-400",
				background: "from-purple-50 to-amber-50",
				cardBackground: "from-amber-50 to-orange-50",
			},
		},
		fonts: {
			heading: "font-bold",
			body: "font-normal",
		},
	},
	securityItems: {
		conformidadeDeclarada: [
			{
				title: "Holografia Personalizada INMETRO",
				description:
					"A holografia é exclusiva e personalizada INMETRO. Verifique se apresenta variações de imagens, efeitos 3D e brilho como na imagem acima. Se a holografia apresentar imagens diferentes e não for personalizada, pode ser um indício de fraude.",
				image: Img1CD,
			},
			{
				title: "Relevo Tátil com Efeito Iridescente",
				description:
					"Na lateral direita do selo existe uma impressão especial com um pequeno relevo sensível ao tato. Verifique se a impressão também apresenta cintilância e brilho.",
				image: Img2CD,
			},
			{
				title: "Fundo Numismático Anticópia",
				description:
					"Quando colocado na luz UV, o QR Code brilha em tons azulados. Isso ajuda a garantir que ele seja verdadeiro e não falsificado.",
				image: Img3CD,
			},
			{
				title: "Logotipo INMETRO na holografia",
				description:
					"O logo Inmetro estilizado é impresso registrado perfeitamente com a holografia interrompida conforme imagem acima. Se o selo apresentar a impressão do logo sem essas características, pode ser um indício de fraude.",
				image: Img4CD,
			},
			{
				title: "Microtexto Sobre Holografia em Duas Cores",
				description:
					"A tarja holográfica Inmetro contém impressão de microtextos repetidos “Diretoria de Metrologia Legal” quase ilegíveis a olho nu.",
				image: Img5CD,
			},
			{
				title: "Microtextos Positivos e Negativos Impressos no Fundo",
				description:
					"O fundo de segurança apresenta Microtextos “Inmetro” impressos repetidamente em tamanho inferior a 0,5 mm e bem definidos. Se o selo não contiver essa impressão ou se o fundo estiver falhado e sem definição, pode ser um indício de fraude.",
				image: Img6CD,
			},
		],
		seloReparado: [
			{
				title: "Reagente a Luz UV",
				description:
					"Texto 'METROLOGIA LEGAL' invisível a luz normal, apresentando luminescência em luz ultra violeta.",
				image: Img1REP,
			},
			{
				title: "Alta Segurança",
				description:
					"A holografia no selo é exclusiva e de alta segurança. Ela deve apresentar alternância positiva e negativa da palavra 'INMETRO' no mesmo padrão de layout do exemplo acima.",
				image: Img2REP,
			},
			{
				title: "Figuras Geométricas",
				description:
					"Os fundos anticópias apresentam padrões variados e complexos, e podem ser constituído por linhas contínuas e bem definidas em formas geométricas variadas.",
				image: Img3REP,
			},
			{
				title: "Gradual de Cores",
				description:
					"Técnica de impressão usada para criar fundos coloridos de segurança, formados por linhas que mudam de cor de forma suave, sem o uso de pontilhados. Esse método torna o desenho mais nítido e difícil de falsificar.",
				image: Img4REP,
			},
			{
				title: "Marcação Permanente",
				description:
					"É uma numeração alfanumérica sequencial que não pode ser apagada ou removida por nenhum método, seja químico ou mecânico.",
				image: Img5REP,
			},
			{
				title: "VOID",
				description:
					"Processo que torna impossível remover o selo sem deixar marcas claras de violação, como destruição do material ou a palavra “VOID” aparecendo.",
				image: Img6REP,
			},
			{
				title: "Microletras Sobre Holografia",
				description:
					"Microtexto contendo 'METROLOGIA LEGAL' com tamanho máximo de 0,5 mm, podendo ser visto somente com lupa. Possui falhas propositalmente inseridas na impressão, servindo como um recurso de segurança contra falsificações.",
				image: Img7REP,
			},
		],
		subsequente: [
			{
				title: "Holografia Personalizada INMETRO",
				description:
					"A holografia é exclusiva e personalizada INMETRO. Verifique se apresenta variações de imagens, efeitos 3D e brilho como na imagem acima. Se a holografia apresentar imagens diferentes e não for personalizada, pode ser um indício de fraude.",
				image: Img1CD,
			},
			{
				title: "Relevo Tátil com Efeito Iridescente",
				description:
					"Na lateral direita do selo existe uma impressão especial com um pequeno relevo sensível ao tato. Verifique se a impressão também apresenta cintilância e brilho.",
				image: Img2CD,
			},
			{
				title: "Fundo Numismático Anticópia",
				description:
					"Quando colocado na luz UV, o QR Code brilha em tons azulados. Isso ajuda a garantir que ele seja verdadeiro e não falsificado.",
				image: Img3CD,
			},
			{
				title: "Logotipo INMETRO na holografia",
				description:
					"O logo Inmetro estilizado é impresso registrado perfeitamente com a holografia interrompida conforme imagem acima. Se o selo apresentar a impressão do logo sem essas características, pode ser um indício de fraude.",
				image: Img4CD,
			},
			{
				title: "Microtexto Sobre Holografia em Duas Cores",
				description:
					"A tarja holográfica Inmetro contém impressão de microtextos repetidos “Diretoria de Metrologia Legal” quase ilegíveis a olho nu.",
				image: Img5CD,
			},
			{
				title: "Microtextos Positivos e Negativos Impressos no Fundo",
				description:
					"O fundo de segurança apresenta Microtextos “Inmetro” impressos repetidamente em tamanho inferior a 0,5 mm e bem definidos. Se o selo não contiver essa impressão ou se o fundo estiver falhado e sem definição, pode ser um indício de fraude.",
				image: Img6CD,
			},
		],
		// Apenas para ter valores defaults em DEV
		validador: [
			{
				title: "Holografia Personalizada INMETRO",
				description:
					"A holografia é exclusiva e personalizada INMETRO. Verifique se apresenta variações de imagens, efeitos 3D e brilho como na imagem acima. Se a holografia apresentar imagens diferentes e não for personalizada, pode ser um indício de fraude.",
				image: Img1CD,
			},
			{
				title: "Relevo Tátil com Efeito Iridescente",
				description:
					"Na lateral direita do selo existe uma impressão especial com um pequeno relevo sensível ao tato. Verifique se a impressão também apresenta cintilância e brilho.",
				image: Img2CD,
			},
			{
				title: "Fundo Numismático Anticópia",
				description:
					"Quando colocado na luz UV, o QR Code brilha em tons azulados. Isso ajuda a garantir que ele seja verdadeiro e não falsificado.",
				image: Img3CD,
			},
			{
				title: "Logotipo INMETRO na holografia",
				description:
					"O logo Inmetro estilizado é impresso registrado perfeitamente com a holografia interrompida conforme imagem acima. Se o selo apresentar a impressão do logo sem essas características, pode ser um indício de fraude.",
				image: Img4CD,
			},
			{
				title: "Microtexto Sobre Holografia em Duas Cores",
				description:
					"A tarja holográfica Inmetro contém impressão de microtextos repetidos “Diretoria de Metrologia Legal” quase ilegíveis a olho nu.",
				image: Img5CD,
			},
			{
				title: "Microtextos Positivos e Negativos Impressos no Fundo",
				description:
					"O fundo de segurança apresenta Microtextos “Inmetro” impressos repetidamente em tamanho inferior a 0,5 mm e bem definidos. Se o selo não contiver essa impressão ou se o fundo estiver falhado e sem definição, pode ser um indício de fraude.",
				image: Img6CD,
			},
		],
	},
	settings: {
		enableQRCode: true,
		enableMap: true,
		enableReports: true,
		maxSealsPerBatch: 5000,
		enablePublicHash: false,
	},
}
